"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StovesHousesNamibiaConstants = void 0;
class StovesHousesNamibiaConstants {
    constructor() {
        this.emissionFactor = 0.1;
    }
}
exports.StovesHousesNamibiaConstants = StovesHousesNamibiaConstants;
